export default __webpack_public_path__ + "static/media/parking.8b43adaa.svg";